module.exports = __webpack_public_path__ + "static/media/ortho-image2@2x.6a89eade.png";